// extracted by mini-css-extract-plugin
export var createdDate = "_nu-1";
export var divider = "_nu-2";
export var headerDivider = "_nu-3";
export var messagesCard = "_nu-0";
export var messagesContainer = "_nu-6";
export var messagesContainerWrapper = "_nu-4";
export var showLeftPanelButton = "_nu-8";
export var topButtons = "_nu-7";
export var withPadding = "_nu-5";